import { TYPES } from "../../../config/constants/typesReducers";
import { FddApi } from "../../../ui/services/server-fdd";

const { SIGNATURE } = TYPES;

export const initialStateSignature = {
  "config": {},
  "signature":{
    "header": {
      "title": "",
      "user": {
        "name": "",
        "email": ""
      },
      "date": ""
    },
    "signer": {
      "name": "",
      "email": ""
    },
    // "signedFieldsByPage": { }, //Pendiente ya que aun se necesitan los ids para editar los campos en caso de que el usuario se equivoque
    "fieldsByPage": { }
  }
}

// Función para obtener el estado inicial (carga asíncrona)
export const getInitialStateSignature = async (signRequestId) => {
  // Consultar datos en la API
  const response = FddApi.getDraftData(signRequestId);
  response.then(({body}) => {
    console.log('[SIGNATURE] getInitialStateSignature -> body', body);

  })
};

export const signatureReducer = (
  initialState,
  action = { type: "", payload: "" }
) => {
  switch (action.type) {
    case SIGNATURE.LOAD_SIGNATURE:{
      const {fieldsByPage} = action.payload;

      let sortedFields = {};

      //Ordena de arriba a abajo los campos por posicion
      Object.keys(fieldsByPage).forEach((page) => {
        let orderFieldsByPage = [];
        Object.keys(fieldsByPage[page]).forEach((fieldId, index) => {
          orderFieldsByPage.push(fieldsByPage[page][fieldId]);
          if (index === Object.keys(fieldsByPage[page]).length - 1) {
            orderFieldsByPage.sort((fieldA, fieldB) => fieldA.position.coords.y - fieldB.position.coords.y);
            orderFieldsByPage.forEach((field) => {
              const {id} = field;
              sortedFields[id] = {
                field: {...field},
                focus: false,
                isEmpty: true
              };
            });
          }
        });
      });

      return {
        ...initialStateSignature,
        config:{
          ...initialState.config,
          sortedFields,
        },
        signature:{
          ...action.payload,
        }
      }
    }
    
    case SIGNATURE.EDIT_FIELDS: { 
      //const {page, fieldId, value} = action.payload;
      const {field, value} = action.payload;
      
      // Validar que field existe y tiene las propiedades necesarias
      if (!field || !field.position) {
        console.error('[EDIT_FIELDS] Invalid field:', field);
        return initialState;
      }
      
      const { id, type, position:{page} } = field;

      if (type === 'sign') {
        const copyFieldsByPage = initialState.signature.fieldsByPage;
        const copySortedFields = initialState.config.sortedFields;

        Object.keys(copyFieldsByPage).forEach((pageId)=>{
          Object.keys(copyFieldsByPage[pageId]).forEach((fieldId) => {
            const field = initialState.signature.fieldsByPage[pageId][fieldId];
            if(field.type === 'sign') {
              copyFieldsByPage[pageId][fieldId].value = value;
              copySortedFields[fieldId].isEmpty = !value;
            }
          })
        })

        return {
          ...initialState,
          config:{
            ...initialState.config,
            sortedFields:{
              ...copySortedFields
            }
          },
          signature:{
            ...initialState.signature,
            fieldsByPage: {
              ...copyFieldsByPage,
            },
            sign: value
          }
        }
      }

      return {
        ...initialState,
        config:{
          ...initialState.config,
          sortedFields:{
            ...initialState.config.sortedFields,
            [id]: {
              ...initialState.config.sortedFields[id],
              isEmpty: false
            }
          }
        },
        signature:{
          ...initialState.signature,
          fieldsByPage: {
            ...initialState.signature.fieldsByPage,
            [page]: {
              ...initialState.signature.fieldsByPage[page],
              [id]: {
                ...initialState.signature.fieldsByPage[page][id],
                value: value
              }
            }
          }  
        }
      }
    }

    case SIGNATURE.FOCUS_FIELD:{
      const field = action.payload;
      const {id} = field;

      const copyFieldsByPage = initialState.signature.fieldsByPage;
      Object.keys(copyFieldsByPage).forEach((page)=>{
        Object.keys(copyFieldsByPage[page]).forEach((field) => {
          copyFieldsByPage[page][field].focus = false
        })
      })

      const copySortedFields = initialState.config.sortedFields;
      Object.keys(copySortedFields).forEach((fieldId) => {
        copySortedFields[fieldId].focus = false;
      })

      const { focus, ...data} = field;

      console.log(copyFieldsByPage);

      return{
        ...initialState,
        config:{
          ...initialState.config,
          currentField: {
            ...data,
          },
          sortedFields:{
            ...copySortedFields,
            [id]:{
              ...copySortedFields[id],
              focus: true
            }
          }
        },
      }
    }

    case SIGNATURE.CLEAN:
      return {
        ...initialStateSignature,
      };

    default:
      return initialState;      
  }
};